import { currentLanguage } from '@/i18n';

const UNITS: [Intl.RelativeTimeFormatUnit, number][] = [
  ['year', 365 * 24 * 3600],
  ['month', 30 * 24 * 3600],
  ['week', 7 * 24 * 3600],
  ['day', 24 * 3600],
  ['hour', 3600],
  ['minute', 60],
];

/** "hace 5 minutos" / "5 minutes ago" en el idioma actual. */
export function relativeTime(iso: string, now = Date.now()): string {
  const rtf = new Intl.RelativeTimeFormat(currentLanguage(), { numeric: 'auto' });
  const seconds = Math.round((new Date(iso).getTime() - now) / 1000);
  for (const [unit, size] of UNITS) {
    if (Math.abs(seconds) >= size) return rtf.format(Math.round(seconds / size), unit);
  }
  return rtf.format(0, 'minute');
}

export function dateTime(iso: string): string {
  return new Intl.DateTimeFormat(currentLanguage(), { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(iso));
}

/** Casillas → metros con coma decimal en castellano (1 casilla = 1,5 m). */
export function metersFor(cells: number): string {
  return new Intl.NumberFormat(currentLanguage(), { maximumFractionDigits: 1 }).format(cells * 1.5);
}
